var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AvatarBase,{staticClass:"executive",attrs:{"image":_setup.image,"text":_setup.text,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }